// Tüm site metinleri — TR (varsayılan) + NL. İki ayrı yol: ev sahibi (owner) & kiracı (tenant).
export const translations = {
  tr: {
    langName: "TR",
    nav: { start: "Hemen Başla", admin: "Yönetim", home: "Ana Sayfa", forOwner: "Ev Sahibiyim", forTenant: "Kiracıyım" },

    chooser: {
      badge: "Tüm Hollanda'da Emlak Kiralama Hizmeti",
      title: "Size en hızlı şekilde yardımcı olalım!",
      subtitle:
        "Hollanda'da 10 yıllık kiralama sektörü tecrübesiyle profesyonel ekibimiz sizlere en hızlı şekilde destek verecek. Formu doldurun ve bizden haber bekleyin!",
      owner: {
        title: "Evimi kiraya vermek istiyorum",
        desc: "Mülkünüzü biz devralır, güvenilir kiracıya kiralarız. Sizden hiçbir ücret almayız.",
        highlight: "%100 ücretsiz",
        cta: "Ev Sahibi Olarak Devam Et",
        note: "2 dakika sürer",
      },
      tenant: {
        title: "Kiralık ev arıyorum",
        desc: "Size uygun evleri bulur, ortalama 2 hafta içinde yeni evinize yerleştiririz.",
        highlight: "Ort. 2 haftada ev",
        cta: "Kiracı Olarak Devam Et",
        note: "3 dakika sürer",
      },
      club: {
        title: "Ev Sahipleri Kulübü",
        desc: "Hollanda'daki ev sahiplerinin bir araya geldiği özel topluluk. Güncel bilgiler, uzman buluşmaları ve etkinlikler.",
        highlight: "Ücretsiz",
        cta: "Kulübe Katıl",
        note: "31 Aralık 2026'ya kadar ücretsiz",
      },
      trust: ["1000+ mutlu müşteri", "7-24 iletişim", "Hollanda Geneli", "Profesyonel Ekip", "10 Yıl + Tecrübe"],
    },

    testimonials: {
      overline: "Müşteri Yorumları",
      title: "Binlerce kişi bize güvendi",
      items: [
        { name: "Elif K.", city: "Amsterdam", text: "Aylardır ev bulamıyordum, Hollanda Emlak sayesinde 10 günde taşındım. Her şey Türkçe ve çok hızlıydı." },
        { name: "Mehmet A.", city: "Rotterdam", text: "Ev sahibiyim, tek kuruş ödemeden evimi kiraya verdiler. Kiram her ay eksiksiz yatıyor." },
        { name: "Zeynep D.", city: "Den Haag", text: "Yurt dışında ev aramak korkutucuydu ama ekip her adımda yanımdaydı. Teşekkürler!" },
        { name: "Can T.", city: "Utrecht", text: "Profesyonel, dürüst ve gerçekten hızlılar. 2 hafta içinde evime yerleştim." },
        { name: "Ayşe Y.", city: "Eindhoven", text: "Bütçeme uygun seçenekleri 48 saat içinde gönderdiler. İşim çok kolaylaştı." },
        { name: "Burak S.", city: "Amsterdam", text: "Ev sahibi olarak en sevdiğim şey: hiç stres yok. Kiracıyı buldular, sözleşmeyi hazırladılar." },
        { name: "Selin M.", city: "Haarlem", text: "Türkçe destek olması büyük fark yarattı. Kendimi güvende hissettim." },
        { name: "Emre B.", city: "Groningen", text: "İlk aradığımda hemen dönüş yaptılar, söz verdikleri her şeyi yaptılar. Tavsiye ederim." },
        { name: "Deniz Ç.", city: "Tilburg", text: "Öğrenciyim, ev bulmak çok zordu. Onlar sayesinde uygun bir stüdyoya yerleştim." },
        { name: "Hakan Ö.", city: "Almere", text: "Evimi 3 gün içinde kiraya verdiler ve peşin kira teklif ettiler. İnanılmaz." },
      ],
    },

    about: {
      overline: "Hakkımızda",
      title: "Bir arayışın sonunda doğduk",
      p1: "Hollanda Emlak, çok kişisel bir deneyimden doğdu. Kurucumuz Hollanda'ya ilk geldiğinde, tıpkı Türkiye'deki gibi kolayca kiralık bir ev bulacağını sanıyordu. Ama gerçek hiç öyle olmadı; aylarca süren yorucu bir arayıştan sonra ancak başını sokabileceği bir ev bulabildi.",
      p2: "O süreçte, Türkçe konuşan ve Hollanda'da ev arayan binlerce insanın aynı zorluğu yaşadığını fark etti. Hollanda Emlak tam da bu sorunu çözmek için 2019'da kuruldu. O günden beri yalnızca kiralamaya odaklandık ve 500'ün üzerinde ev sahibine, sayısız kiracıya ana dillerinde, dürüst ve hızlı bir hizmet sunmanın gururunu yaşıyoruz.",
      values: [
        { t: "Türkçe Destek", d: "Hem Türkiye'de hem Hollanda'da yaşamış bir ekip. Sizi ve ihtiyaçlarınızı gerçekten anlıyoruz." },
        { t: "Sadece Kiralama", d: "2019'dan beri yalnızca kiralama yapıyoruz. Tüm tecrübemiz tek bir alanda derinleşti." },
        { t: "Şeffaflık", d: "Gizli ücret yok, sürpriz yok. Ne söz veriyorsak onu yapıyoruz." },
      ],
      stats: [
        { big: "2019", small: "yılından beri sektörde" },
        { big: "500+", small: "mutlu ev sahibi" },
        { big: "%100", small: "Türkçe destek" },
      ],
    },

    club: {
      nav: "Ev Sahipleri Kulübü",
      hero: {
        badge: "Ücretsiz üyelik — Ev sahiplerine özel topluluk",
        title: "Hollanda Ev Sahipleri Kulübü",
        subtitle:
          "Hollanda'daki ev sahiplerinin bir araya geldiği, bilgi ve deneyim paylaştığı, değerli bağlantılar kurduğu özel topluluk. Üyelik tamamen ücretsiz.",
        cta: "Kulübe Ücretsiz Üye Ol",
        note: "2 dakikada başvurun",
        trust: "Ev sahiplerine özel",
      },
      freeNotice: "Kulüp üyeliği 31 Aralık 2026'ya kadar ücretsizdir. Bu tarihten sonra katılan üyelerden ücret alınacaktır.",
      intro: {
        overline: "Kulüp Nedir?",
        title: "Sadece bir bilgi platformu değil, güçlü bir network",
        p1: "Ev sahipleri için özel olarak kurduğumuz bu kulüpte; Hollanda'daki gayrimenkul piyasası, yasal düzenlemeler, yatırımlar, kiralama süreçleri ve alım-satım konularında güncel bilgiler paylaşıyoruz.",
        p2: "Kulübü yalnızca bir bilgi platformu olarak değil; Hollanda'daki ev sahiplerinin bir araya geldiği, deneyimlerini paylaştığı ve değerli bağlantılar kurduğu özel bir network olarak konumlandırıyoruz. Gayrimenkul uzmanlarımız, avukatlar ve finans uzmanlarıyla ara ara toplantılar, webinarlar ve etkinlikler düzenliyoruz.",
      },
      benefits: {
        overline: "Üyelik Avantajları",
        title: "Kulüp üyeleri neler kazanır?",
        items: [
          { t: "Güncel piyasa bilgisi", d: "Gayrimenkul piyasası, yasal düzenlemeler ve yatırım fırsatları hakkında ilk elden, güncel bilgiler." },
          { t: "Uzman toplantıları", d: "Avukatlar, finans ve gayrimenkul uzmanlarıyla düzenli webinar ve toplantılar." },
          { t: "Özel network", d: "Hollanda'daki diğer ev sahipleriyle tanışın, deneyim paylaşın, değerli bağlantılar kurun." },
          { t: "Kiralama & alım-satım", d: "Kiralama süreçleri ve alım-satım konularında pratik, uygulanabilir rehberlik." },
          { t: "Özel etkinlikler", d: "2027'de düzenleyeceğimiz özel buluşmalarla üyelerimizi bir araya getiriyoruz." },
          { t: "%100 ücretsiz", d: "Kulüp üyeliği tamamen ücretsizdir. Hiçbir aidat veya gizli masraf yoktur." },
        ],
      },
      events: {
        overline: "2027 Etkinlikleri",
        title: "Üyelerimizi bir araya getiriyoruz",
        body: "2027 yılında düzenleyeceğimiz özel etkinliklerle üyelerimizi bir araya getirmeyi hedefliyoruz. Hollanda'da bir gayrimenkul sahibiyseniz veya yatırım yapmayı düşünüyorsanız, siz de bu topluluğun bir parçası olabilirsiniz.",
      },
      form: {
        overline: "Üyelik Başvurusu",
        title: "Kulübe ücretsiz üye olun",
        subtitle: "Bilgilerinizi bırakın, sizi aramıza katalım. Üyelik tamamen ücretsizdir.",
        labels: {
          name: "Ad Soyad", phone: "Telefon", email: "E-posta", city: "Şehir (ops.)",
          owns: "Hollanda'da gayrimenkul sahibi misiniz?", interest: "İlgi alanınız (ops.)",
          message: "Eklemek istedikleriniz (ops.)", channel: "Tercih edilen iletişim kanalı",
          consent: "Kişisel verilerimin işlenmesini (AVG/GDPR) kabul ediyorum.",
        },
        ownsOptions: ["Evet", "Hayır", "Yatırım yapmayı düşünüyorum"],
        interestOptions: ["Yatırım", "Kiralama", "Alım-Satım", "Yasal süreçler", "Network"],
        submit: "Ücretsiz Üye Ol", submitting: "Gönderiliyor…",
      },
      thanks: {
        title: "Aramıza hoş geldiniz!",
        body: "Üyelik başvurunuzu aldık. Kısa süre içinde sizi aramıza katıp etkinlik ve güncel bilgilerden ilk siz haberdar olacaksınız.",
        reminder: "Üyelik tamamen ücretsizdir.",
      },
      homeCard: {
        overline: "Yeni",
        title: "Ev Sahipleri Kulübü'ne katılın",
        desc: "Hollanda'daki ev sahiplerinin bir araya geldiği özel topluluk. Güncel bilgiler, uzman buluşmaları ve etkinlikler — üyelik tamamen ücretsiz.",
        cta: "Kulübü Keşfet",
        note: "Ücretsiz üyelik",
      },
    },

    owner: {
      hero: {
        badge: "Ev sahipleri için %100 ücretsiz — kiranızı eksiksiz alırsınız",
        title: "Mülkünüzü devralıyor, stresinizi üstleniyoruz.",
        subtitle:
          "Evinizi doğrudan biz kiralıyoruz. Evim boş kaldı mı, kiracı kiramı ödeyecek mi, ay sonunda bir sorun yaşar mıyım gibi tüm dertlerden kurtarmakla kalmıyor, evde oluşabilecek problemlerin %99'unu da kendi teknik ekibimizle ücretsiz çözüyoruz.",
        cta: "Ücretsiz Değerlendirme Al",
        note: "2 dakikada başvurun — hemen dönüş yaparız",
      },
      stats: [
        { big: "0€", small: "ev sahibinden hiçbir ücret almıyoruz!" },
        { big: "%100", small: "kiranızı eksiksiz ve zamanında alırsınız!" },
        { big: "24 SAAT", small: "içinde dönüş — 72 saatte evinizi kiralayabiliyoruz!" },
      ],
      sales: {
        overline: "Neden Hollanda Emlak?",
        title: "Kiraya vermenin en kolay ve en kârlı yolu",
        cards: [
          { t: "Tek kuruş ödemezsiniz", d: "Değerlendirme, kiracı bulma, evrak ve sözleşme — hepsi ücretsiz. Komisyon, dosya masrafı veya abonelik yok." },
          { t: "Kiranız eksiksiz yatar", d: "Belirlediğiniz kira miktarını tam olarak alırsınız. Bizim gelirimiz sizin cebinizden çıkmaz." },
          { t: "Uğraşı biz üstleniriz", d: "Kiracı bulma, görüşme, evrak ve sözleşme sürecinin tamamını biz yönetiriz. Siz sadece kiranızı alırsınız." },
          { t: "Güvenilir kiracı", d: "Gelir belgesi, işveren yazısı ve referans kontrolüyle kiracıyı biz eleriz." },
          { t: "Türkçe iletişim", d: "Tüm süreç boyunca ana dilinizde net ve hızlı destek." },
          { t: "Mevzuata uygunluk", d: "Huurcommissie ve Hollanda kira mevzuatına uygun, güvenli sözleşme." },
        ],
      },
      whyFree: {
        overline: "Şeffaflık",
        title: "Nasıl mı oluyor? İşte nasıl kazanç elde ettiğimizi anlatıyoruz.",
        cards: [
          { t: "Sizden hiçbir ücret almıyoruz", d: "Mülkünüzü değerlendirme, kiracı bulma, evrak ve sözleşme sürecinin tamamı ücretsizdir." },
          { t: "Kiranızı eksiksiz alırsınız", d: "Belirlediğiniz kira miktarını tam olarak alırsınız. Ondan kesinti yapmıyoruz." },
          { t: "Peki nasıl kazanıyoruz?", d: "Biz aracı değiliz; mülkünüzü doğrudan kendimiz kiralıyoruz ve kiracıya kendi sözleşmemizle sunuyoruz. Gelirimiz bu iki kira arasındaki farktan gelir — sizin cebinizden değil." },
        ],
      },
      steps: {
        overline: "Nasıl Çalışır",
        title: "Üç adımda kira geliriniz başlasın!",
        items: [
          { n: "01", t: "Formu doldurun", d: "Mülkünüzün bilgilerini 2 dakikada paylaşın." },
          { n: "02", t: "Değerlendirip teklif sunarız", d: "Mülkünüzü değerlendirir, kira teklifimizi iletiriz." },
          { n: "03", t: "Sözleşme ve düzenli kira", d: "Sözleşmeyi imzalayın, kiranız her ay düzenli yatsın." },
        ],
      },
      faq: {
        overline: "Ev Sahibi SSS",
        title: "Ev sahiplerinin en çok sorduğu sorular",
        items: [
          { q: "Ev sahibi olarak gerçekten hiç ücret ödemeyecek miyim?", a: "Evet. Değerlendirme, kiracı bulma, evrak ve sözleşme dahil hiçbir aşamada sizden ücret almıyoruz. Komisyon, dosya masrafı, ilan ücreti veya abonelik yoktur." },
          { q: "Peki siz nasıl kazanıyorsunuz?", a: "Biz aracı değiliz. Mülkünüzü doğrudan kiralıyoruz ve kiracıya kendi sözleşmemizle sunuyoruz. Gelirimiz, kiracıya sunduğumuz kira ile size ödediğimiz kira arasındaki farktan gelir — sizin cebinizden değil." },
          { q: "Kiramı ne zaman ve nasıl alırım?", a: "Belirlediğiniz kira, sözleşmede kararlaştırılan günde her ay düzenli olarak hesabınıza yatırılır. Sizinle yapılan sözleşmenin başlangıç tarihinden bitiş tarihine kadar evinizde kiracının olup olmamasına bakılmaksızın kiranız yatmaya başlar. Evinizin boş kalıp kalmamasının stresini yaşamak yerine, sektördeki tecrübemizle evinizin tüm risk analizini çıkartıp doğru stratejiyle kiralama gerçekleştiriyoruz. Eviniz boş kalsa da kalmasa da kiranızı sözleşme tarihlerine bağlı olarak her ay alıyorsunuz. Hatta bazı anlaşmalarımızda 3 ay, 6 ay veya 12 ay gibi peşin kira ödemesi bile gerçekleştiriyoruz." },
          { q: "Kira sözleşmesini kim hazırlıyor ve kiracıyı kim buluyor?", a: "Kira sözleşmeleri hukuk ekibimiz tarafından hazırlanmış şablonlardan uygun olanı sizinle paylaşılır. Tüm sözleşmelerimiz Hollanda Kiralama Hukuku'na uygun şekilde hazırlanmıştır. Kiracıyı biz buluruz; fakat tekrar hatırlatmak isteriz, evde kiracı olup olmamasından bağımsız olarak sözleşmemizin başlama tarihinden itibaren kiranızı almaya başlarsınız." },
          { q: "Hangi evrakları hazırlamam gerekiyor?", a: "Genellikle tapu/mülkiyet bilgisi ve mülke ait temel belgeler yeterlidir. Size özel olarak hangi belgelerin gerektiğini net biçimde iletiriz." },
          { q: "Süreç ne kadar sürer?", a: "Formu doldurduktan sonra 24 saat içinde size dönüş yapar, süreci telefonda anlatırız; ardından 24 saat içinde evinizi ziyaret eder, sonraki 24 saat içinde de sözleşmenizi göndeririz ve hemen kiralamaya başlayabiliriz. 72 saat içinde, hiçbir ücret ödemeden evinizi kiralama sözü veriyoruz!" },
        ],
      },
    },

    tenant: {
      hero: {
        badge: "Ortalama 2 hafta içinde yeni evinizdesiniz",
        title: "Hollanda'da hayalinizdeki evi birlikte bulalım.",
        subtitle:
          "Bütçenize ve kriterlerinize uygun evleri sizin için bulur, tüm süreçte Türkçe destek veririz. Evi doğrudan bizden, güvenli sözleşmeyle kiralarsınız.",
        cta: "Ücretsiz Ev Araması Başlat",
        note: "3 dakikada talebinizi bırakın — 48 saatte dönüş",
      },
      metrics: {
        overline: "Ne kadar sürede?",
        title: "Süreç net, hızlı ve şeffaf",
        items: [
          { big: "48 SAAT", small: "ilk geri dönüş" },
          { big: "2 HAFTA", small: "ortalama yerleşme süresi" },
          { big: "6 HAFTA", small: "maksimum süre" },
        ],
        disclaimer:
          "Bütçeniz ve kriterleriniz piyasa koşullarıyla uyumluysa, müşterilerimizin büyük çoğunluğunu ortalama 2 hafta, en geç 6 hafta içinde evine yerleştiriyoruz.",
      },
      sales: {
        overline: "Neden Hollanda Emlak?",
        title: "Ev bulmanın en hızlı ve en huzurlu yolu",
        cards: [
          { t: "Hızlı eşleştirme", d: "Kriterlerinize uygun evleri sizin için araştırır, en uygun seçenekleri 48 saat içinde göndeririz." },
          { t: "Türkçe destek", d: "Görüşmeden sözleşmeye kadar her adımda ana dilinizde yanınızdayız." },
          { t: "Güvenli sözleşme", d: "Evi doğrudan Hollanda Emlak'tan, bizim kira sözleşmemizle kiralarsınız." },
          { t: "Tecrübeli Danışmanlar", d: "Sektörde 10 yıl+ tecrübeli ekip yönetimiyle profesyonel süreç yönetimi." },
          { t: "Şeffaf süreç", d: "Gizli masraf yok, sürpriz yok. Ne beklemeniz gerektiğini baştan biliriz." },
          { t: "1 Yıl Ücretsiz Destek", d: "Uygun ev bulunduktan sonraki 1 yıl içinde kiralanan evle ilgili ücretsiz tam süreç desteği." },
        ],
      },
      steps: {
        overline: "Nasıl Çalışır",
        title: "Üç adımda yeni evinize",
        items: [
          { n: "01", t: "Formu doldurun", d: "3 dakika — ne aradığınızı bize anlatın." },
          { n: "02", t: "Size uygun evleri gönderelim", d: "48 saat içinde ilk seçenekleri paylaşırız." },
          { n: "03", t: "Görüntüleme ve sözleşme", d: "Ortalama 2 hafta içinde evinize yerleşin." },
        ],
        disclosureShort: "",
      },
      faq: {
        overline: "Kiracı SSS",
        title: "Kiracıların en çok sorduğu sorular",
        items: [
          { q: "Kiracı olarak evi kimden kiralıyorum?", a: "Bütçenize, belge durumunuza ve arama kriterlerinize bağlı olarak bireysel ev sahiplerinden ya da kurumsal ev şirketlerinden kiralamanıza yardımcı oluyoruz." },
          { q: "Ne kadar sürede ev bulurum?", a: "Bütçeniz ve kriterleriniz piyasa koşullarıyla uyumluysa, müşterilerimizin büyük çoğunluğunu ortalama 2 hafta, en geç 6 hafta içinde evine yerleştiriyoruz. Bu bir garanti değil, ortalama performansımızdır." },
          { q: "6 hafta içinde ev bulunamazsa ne oluyor?", a: "Açık söylemek gerekirse, daha önce hiç başımıza gelmediği için bilmiyoruz! :) Ama eğer 6 hafta içinde bir ev bulunamazsa bizden hiçbir fatura almaz ve bize hiçbir şey ödemezsiniz. Daha önce herhangi bir ödeme yaptıysanız da bu tamamen size geri ödenir." },
          { q: "Hangi belgeleri hazırlamalıyım?", a: "Genellikle kimlik, gelir belgesi ve işveren yazısı gibi standart belgeler istenir. Bazı durumlarda önceki ev sahibi referansı da faydalı olur; hangi belgelerin gerektiğini size iletiriz." },
          { q: "Hangi şehirlerde hizmet veriyorsunuz?", a: "Tüm Hollanda genelinde hizmet veriyoruz. Amsterdam, Rotterdam, Den Haag, Utrecht, Eindhoven ve diğer tüm şehirlerdeki taleplerinizi değerlendiriyoruz." },
        ],
      },
    },

    form: {
      overline: "Başlayın",
      ownerTitle: "Mülkünüz için ücretsiz değerlendirme",
      tenantTitle: "Size uygun evleri bulalım",
      step: "Adım",
      of: "/",
      next: "Devam",
      back: "Geri",
      submit: "Talebi Gönder",
      submitting: "Gönderiliyor…",
      ownerReminder: "Bu hizmet ev sahipleri için tamamen ücretsizdir. Belirlediğiniz kirayı eksiksiz alırsınız.",
      addressPrivacy: "Adres bilgileriniz yalnızca mülkünüzü değerlendirmek için kullanılır ve üçüncü kişilerle paylaşılmaz.",
      tenantDisclosure: "Onaylayarak, evi mülk sahibinden değil doğrudan Hollanda Emlak'tan kiralayacağınızı kabul edersiniz.",
      steps: { look: "Ne Arıyorsunuz", situation: "Durum Bilgisi", contact: "İletişim", property: "Mülk Bilgileri", rental: "Kiralama Detayları" },
      labels: {
        postcode: "Postcode", huisnummer: "Kapı no", toevoeging: "Ek (ops.)", street: "Sokak adı", city: "Şehir",
        manualToggle: "Adresi elle girmek istiyorum", addressConfirm: "Doğru mu?",
        propertyType: "Mülk tipi", rooms: "Oda sayısı", sqm: "Metrekare (m²)", furnishing: "Eşya durumu",
        rent: "Aylık istenen kira (€)", availableDate: "Müsait olma tarihi", inschrijving: "Inschrijving (BRP) veriliyor mu?",
        description: "Ek açıklama (ops.)", photos: "Fotoğraf yükle (ops., max 5)",
        name: "Ad Soyad", phone: "Telefon", email: "E-posta", channel: "Tercih edilen iletişim kanalı",
        consent: "Kişisel verilerimin işlenmesini (AVG/GDPR) kabul ediyorum.",
        cities: "Aradığınız şehir(ler)", citiesPlaceholder: "Şehir yazın, Enter'a basın",
        minRooms: "Minimum oda sayısı", budget: "Aylık bütçe (€)", moveDate: "Taşınma tarihi",
        stayDuration: "Planlanan kalış süresi", occupants: "Kaç kişi kalacak", workStatus: "Çalışma durumu",
        income: "Yıllık brüt gelir aralığı", pets: "Evcil hayvan", smoking: "Sigara", inschrijvingNeeded: "Inschrijving gerekli mi?",
      },
      options: {
        propertyTypeOwner: ["Daire", "Müstakil ev", "Stüdyo", "Oda", "Diğer"],
        propertyTypeTenant: ["Daire", "Müstakil ev", "Stüdyo", "Oda", "Farketmez"],
        furnishing: ["Eşyalı", "Yarı eşyalı", "Boş"],
        yesNoMaybe: ["Evet", "Hayır", "Görüşülür"], yesNo: ["Evet", "Hayır"],
        channel: ["WhatsApp", "Telefon", "E-posta"], stay: ["6 ay", "1 yıl", "2+ yıl", "Belirsiz"],
        work: ["Sözleşmeli iş", "Belirli süreli", "ZZP", "Öğrenci", "Emekli", "Diğer"],
        income: ["25.000€ altı", "25.000–40.000€", "40.000–60.000€", "60.000€ üzeri"], pets: ["Var", "Yok"],
      },
      budgetWarning: "Bu şehirde bu bütçeyle süreç uzayabilir — size en uygun seçenekleri yine de göndeririz.",
      errors: {
        required: "Bu alan zorunlu", postcode: "Geçerli bir postcode girin (1234 AB)",
        email: "Geçerli bir e-posta girin", phone: "Geçerli bir telefon girin", consent: "Devam etmek için onaylamanız gerekir",
      },
      thanksOwner: { title: "Talebiniz alındı!", body: "24 saat içinde WhatsApp'tan ulaşacağız.", reminder: "Hatırlatma: Bu hizmet sizin için tamamen ücretsizdir." },
      thanksTenant: { title: "Talebiniz alındı!", body: "48 saat içinde size uygun ilanları göndermeye başlayacağız.", reminder: "Ortalama yerleşme sürecimiz 2 haftadır." },
      followInsta: "Instagram'da takip et",
    },

    footer: {
      tagline: "Hollanda'da güvenilir kiralama. Aracı değil, doğrudan kiralayan.",
      contact: "İletişim", links: "Bağlantılar", privacy: "Gizlilik Politikası", terms: "Kullanım Şartları",
      kvk: "KVK No", btw: "BTW No", rights: "Tüm hakları saklıdır.",
    },
    cookie: {
      text: "Deneyiminizi iyileştirmek ve trafiği analiz etmek için çerez kullanıyoruz. Analitik çerezler için onayınızı rica ederiz.",
      accept: "Kabul Et", reject: "Sadece Gerekli", link: "Gizlilik Politikası",
    },
    legal: { privacyTitle: "Gizlilik Politikası", termsTitle: "Kullanım Şartları", close: "Kapat" },
    whatsapp: "WhatsApp'tan yazın",
  },

  nl: {
    langName: "NL",
    nav: { start: "Direct Beginnen", admin: "Beheer", home: "Home", forOwner: "Verhuurder", forTenant: "Huurder" },

    chooser: {
      badge: "Woningverhuur in heel Nederland",
      title: "Laat ons u zo snel mogelijk helpen!",
      subtitle:
        "Met 10 jaar ervaring in de Nederlandse verhuursector staat ons professionele team klaar om u zo snel mogelijk te helpen. Vul het formulier in en wij nemen contact met u op!",
      owner: {
        title: "Ik wil mijn woning verhuren",
        desc: "Wij nemen uw woning over en verhuren deze aan een betrouwbare huurder. U betaalt niets.",
        highlight: "100% gratis",
        cta: "Verder als verhuurder",
        note: "Duurt 2 minuten",
      },
      tenant: {
        title: "Ik zoek een huurwoning",
        desc: "Wij vinden passende woningen en plaatsen u gemiddeld binnen 2 weken.",
        highlight: "Gem. 2 weken",
        cta: "Verder als huurder",
        note: "Duurt 3 minuten",
      },
      club: {
        title: "Verhuurdersclub",
        desc: "De exclusieve community voor verhuurders in Nederland. Actuele kennis, expertbijeenkomsten en evenementen.",
        highlight: "Gratis",
        cta: "Word lid",
        note: "Gratis t/m 31 december 2026",
      },
      trust: ["1000+ tevreden klanten", "7/24 bereikbaar", "Heel Nederland", "Professioneel team", "10+ jaar ervaring"],
    },

    testimonials: {
      overline: "Klantbeoordelingen",
      title: "Duizenden mensen vertrouwden op ons",
      items: [
        { name: "Elif K.", city: "Amsterdam", text: "Ik zocht al maanden een woning; dankzij Hollanda Emlak verhuisde ik binnen 10 dagen. Alles ging snel en in het Turks." },
        { name: "Mehmet A.", city: "Rotterdam", text: "Als verhuurder heb ik niets betaald en toch mijn woning verhuurd. Mijn huur komt elke maand volledig binnen." },
        { name: "Zeynep D.", city: "Den Haag", text: "In het buitenland een huis zoeken was eng, maar het team stond bij elke stap naast me. Bedankt!" },
        { name: "Can T.", city: "Utrecht", text: "Professioneel, eerlijk en echt snel. Binnen 2 weken zat ik in mijn woning." },
        { name: "Ayşe Y.", city: "Eindhoven", text: "Binnen 48 uur stuurden ze opties binnen mijn budget. Het maakte alles zoveel makkelijker." },
        { name: "Burak S.", city: "Amsterdam", text: "Wat ik als verhuurder het fijnst vond: geen stress. Ze vonden de huurder en regelden het contract." },
        { name: "Selin M.", city: "Haarlem", text: "Ondersteuning in het Turks maakte een groot verschil. Ik voelde me veilig." },
        { name: "Emre B.", city: "Groningen", text: "Bij mijn eerste telefoontje reageerden ze direct en deden ze alles wat ze beloofden. Aanrader." },
        { name: "Deniz Ç.", city: "Tilburg", text: "Als student was een woning vinden erg lastig. Dankzij hen zit ik nu in een passende studio." },
        { name: "Hakan Ö.", city: "Almere", text: "Ze verhuurden mijn woning binnen 3 dagen en boden zelfs vooruitbetaalde huur. Ongelooflijk." },
      ],
    },

    about: {
      overline: "Over ons",
      title: "Ontstaan uit een lange zoektocht",
      p1: "Hollanda Emlak ontstond uit een zeer persoonlijke ervaring. Toen onze oprichter voor het eerst naar Nederland kwam, dacht hij net zo makkelijk een huurwoning te vinden als in Turkije. De realiteit was heel anders; na maandenlang uitputtend zoeken vond hij pas een dak boven zijn hoofd.",
      p2: "Tijdens dat proces besefte hij dat duizenden Turks sprekende mensen in Nederland dezelfde moeilijkheid ervaren. Hollanda Emlak werd in 2019 opgericht om precies dit probleem op te lossen. Sindsdien richten wij ons uitsluitend op verhuur en zijn we er trots op meer dan 500 verhuurders en talloze huurders in hun eigen taal, eerlijk en snel te hebben geholpen.",
      values: [
        { t: "Turkse ondersteuning", d: "Een team dat zowel in Turkije als in Nederland heeft geleefd. Wij begrijpen u en uw behoeften echt." },
        { t: "Alleen verhuur", d: "Sinds 2019 doen wij uitsluitend verhuur. Al onze ervaring is in één vakgebied verdiept." },
        { t: "Transparantie", d: "Geen verborgen kosten, geen verrassingen. Wat we beloven, doen we." },
      ],
      stats: [
        { big: "2019", small: "actief sinds" },
        { big: "500+", small: "tevreden verhuurders" },
        { big: "100%", small: "Turkse ondersteuning" },
      ],
    },

    club: {
      nav: "Verhuurdersclub",
      hero: {
        badge: "Gratis lidmaatschap — exclusief voor verhuurders",
        title: "Nederlandse Verhuurdersclub",
        subtitle:
          "De exclusieve community waar verhuurders in Nederland samenkomen, kennis en ervaring delen en waardevolle connecties opbouwen. Lidmaatschap is volledig gratis.",
        cta: "Word gratis lid",
        note: "Aanmelden in 2 minuten",
        trust: "Exclusief voor verhuurders",
      },
      freeNotice: "Het clublidmaatschap is gratis t/m 31 december 2026. Deelnemers die zich daarna aanmelden, betalen een bijdrage.",
      intro: {
        overline: "Wat is de club?",
        title: "Niet alleen een kennisplatform, maar een sterk netwerk",
        p1: "In deze club speciaal voor verhuurders delen we actuele informatie over de Nederlandse vastgoedmarkt, wet- en regelgeving, investeringen, verhuurprocessen en aan- en verkoop.",
        p2: "We positioneren de club niet alleen als kennisplatform, maar als een exclusief netwerk waar verhuurders in Nederland samenkomen, ervaringen delen en waardevolle connecties opbouwen. Met onze vastgoedexperts, advocaten en financieel specialisten organiseren we regelmatig bijeenkomsten, webinars en evenementen.",
      },
      benefits: {
        overline: "Voordelen van lidmaatschap",
        title: "Wat krijgen clubleden?",
        items: [
          { t: "Actuele marktinformatie", d: "Uit eerste hand actuele informatie over de vastgoedmarkt, wetgeving en investeringskansen." },
          { t: "Expertbijeenkomsten", d: "Regelmatige webinars en bijeenkomsten met advocaten, financieel en vastgoedexperts." },
          { t: "Exclusief netwerk", d: "Ontmoet andere verhuurders in Nederland, deel ervaringen en bouw waardevolle connecties op." },
          { t: "Verhuur & aan-/verkoop", d: "Praktische, toepasbare begeleiding bij verhuurprocessen en aan- en verkoop." },
          { t: "Speciale evenementen", d: "In 2027 brengen we onze leden samen tijdens speciale bijeenkomsten." },
          { t: "100% gratis", d: "Het lidmaatschap is volledig gratis. Geen contributie of verborgen kosten." },
        ],
      },
      events: {
        overline: "Evenementen 2027",
        title: "We brengen onze leden samen",
        body: "In 2027 willen we onze leden samenbrengen met speciale evenementen. Bent u vastgoedeigenaar in Nederland of overweegt u te investeren? Dan kunt u ook deel uitmaken van deze community.",
      },
      form: {
        overline: "Aanmelding",
        title: "Word gratis lid van de club",
        subtitle: "Laat uw gegevens achter en we verwelkomen u. Lidmaatschap is volledig gratis.",
        labels: {
          name: "Naam", phone: "Telefoon", email: "E-mail", city: "Plaats (opt.)",
          owns: "Bezit u vastgoed in Nederland?", interest: "Uw interesse (opt.)",
          message: "Toelichting (opt.)", channel: "Voorkeurskanaal voor contact",
          consent: "Ik ga akkoord met de verwerking van mijn persoonsgegevens (AVG/GDPR).",
        },
        ownsOptions: ["Ja", "Nee", "Ik overweeg te investeren"],
        interestOptions: ["Investering", "Verhuur", "Aan-/verkoop", "Juridische processen", "Netwerk"],
        submit: "Word gratis lid", submitting: "Versturen…",
      },
      thanks: {
        title: "Welkom bij de club!",
        body: "We hebben uw aanmelding ontvangen. Binnenkort verwelkomen we u en ontvangt u als eerste nieuws over evenementen en actuele informatie.",
        reminder: "Het lidmaatschap is volledig gratis.",
      },
      homeCard: {
        overline: "Nieuw",
        title: "Word lid van de Verhuurdersclub",
        desc: "De exclusieve community voor verhuurders in Nederland. Actuele kennis, expertbijeenkomsten en evenementen — lidmaatschap is volledig gratis.",
        cta: "Ontdek de club",
        note: "Gratis lidmaatschap",
      },
    },

    owner: {
      hero: {
        badge: "100% gratis voor verhuurders — u ontvangt uw volledige huur",
        title: "Wij nemen uw woning over en nemen de stress weg.",
        subtitle:
          "Wij verhuren uw woning rechtstreeks. Wij nemen niet alleen alle zorgen weg — staat mijn woning leeg, betaalt de huurder wel, krijg ik aan het eind van de maand problemen — maar lossen ook 99% van eventuele problemen in de woning gratis op met ons eigen technische team.",
        cta: "Gratis taxatie aanvragen",
        note: "Aanvraag in 2 minuten — we reageren snel",
      },
      stats: [
        { big: "€0", small: "wij rekenen de verhuurder niets!" },
        { big: "100%", small: "u ontvangt uw huur volledig en op tijd!" },
        { big: "24 UUR", small: "reactietijd — binnen 72 uur verhuurd!" },
      ],
      sales: {
        overline: "Waarom Hollanda Emlak?",
        title: "De makkelijkste en meest winstgevende manier om te verhuren",
        cards: [
          { t: "U betaalt niets", d: "Taxatie, huurder vinden, documenten en contract — allemaal gratis. Geen commissie, dossierkosten of abonnement." },
          { t: "Uw volledige huur", d: "U ontvangt precies het huurbedrag dat u bepaalt. Onze inkomsten komen niet uit uw zak." },
          { t: "Wij nemen het werk over", d: "Huurder vinden, gesprekken, documenten en contract regelen wij volledig. U ontvangt alleen uw huur." },
          { t: "Betrouwbare huurder", d: "Wij screenen de huurder met inkomensbewijs, werkgeversverklaring en referenties." },
          { t: "Turkse communicatie", d: "Duidelijke, snelle ondersteuning in uw eigen taal gedurende het hele traject." },
          { t: "Conform wetgeving", d: "Veilig contract conform de Huurcommissie en Nederlandse huurwetgeving." },
        ],
      },
      whyFree: {
        overline: "Transparantie",
        title: "Hoe werkt dat dan? Zo leggen we uit hoe wij verdienen.",
        cards: [
          { t: "Wij rekenen u niets", d: "De taxatie, het vinden van een huurder, alle documenten en het contract zijn volledig gratis." },
          { t: "U ontvangt uw volledige huur", d: "U ontvangt precies het huurbedrag dat u bepaalt. Wij houden er niets van in." },
          { t: "Hoe verdienen wij dan?", d: "Wij zijn geen bemiddelaar; wij huren uw woning zelf en verhuren deze met ons eigen contract aan de huurder. Onze inkomsten komen uit het verschil tussen die twee huren — niet uit uw zak." },
        ],
      },
      steps: {
        overline: "Hoe het werkt",
        title: "In drie stappen begint uw huurinkomen!",
        items: [
          { n: "01", t: "Vul het formulier in", d: "Deel de gegevens van uw woning in 2 minuten." },
          { n: "02", t: "Wij taxeren en doen een aanbod", d: "Wij beoordelen uw woning en doen ons huuraanbod." },
          { n: "03", t: "Contract en vaste huur", d: "Onderteken het contract en ontvang elke maand stipt uw huur." },
        ],
      },
      faq: {
        overline: "Verhuurder FAQ",
        title: "Meestgestelde vragen van verhuurders",
        items: [
          { q: "Betaal ik als verhuurder echt helemaal niets?", a: "Ja. In geen enkele fase — taxatie, huurder vinden, documenten en contract — rekenen wij u kosten. Geen commissie, dossierkosten, advertentiekosten of abonnement." },
          { q: "Hoe verdienen jullie dan?", a: "Wij zijn geen bemiddelaar. Wij huren uw woning rechtstreeks en verhuren deze met ons eigen contract aan de huurder. Onze inkomsten komen uit het verschil tussen de huur die de huurder betaalt en de huur die wij u betalen — niet uit uw zak." },
          { q: "Wanneer en hoe ontvang ik mijn huur?", a: "Uw vastgestelde huur wordt elke maand op de afgesproken dag op uw rekening gestort. Vanaf de startdatum tot de einddatum van uw contract ontvangt u uw huur, ongeacht of er een huurder in de woning zit. In plaats van de stress van leegstand maken wij met onze ervaring een volledige risicoanalyse en verhuren we met de juiste strategie. Of uw woning nu leegstaat of niet, u ontvangt uw huur elke maand volgens de contractdata. Bij sommige afspraken betalen wij zelfs 3, 6 of 12 maanden huur vooruit." },
          { q: "Wie stelt het contract op en wie vindt de huurder?", a: "Onze juridische afdeling stelt de contractsjablonen op en wij delen het passende contract met u. Al onze contracten voldoen aan het Nederlandse huurrecht. Wij vinden de huurder; maar nogmaals: ongeacht of er een huurder in de woning zit, ontvangt u uw huur vanaf de startdatum van ons contract." },
          { q: "Welke documenten moet ik aanleveren?", a: "Meestal volstaan eigendomsgegevens en basisdocumenten van de woning. We laten u precies weten welke documenten nodig zijn." },
          { q: "Hoe lang duurt het proces?", a: "Na het invullen van het formulier reageren we binnen 24 uur en leggen we het proces telefonisch uit; daarna bezoeken we binnen 24 uur uw woning en sturen we binnen de volgende 24 uur uw contract, waarna we direct kunnen starten. Binnen 72 uur beloven we uw woning te verhuren, zonder enige kosten!" },
        ],
      },
    },

    tenant: {
      hero: {
        badge: "Gemiddeld binnen 2 weken in uw nieuwe woning",
        title: "Samen vinden we uw ideale woning in Nederland.",
        subtitle:
          "Wij zoeken woningen die passen bij uw budget en criteria, met Turkse ondersteuning in het hele traject. U huurt rechtstreeks van ons, met een veilig contract.",
        cta: "Gratis woningzoektocht starten",
        note: "Aanvraag in 3 minuten — reactie binnen 48 uur",
      },
      metrics: {
        overline: "Hoe snel?",
        title: "Een helder, snel en transparant proces",
        items: [
          { big: "48 UUR", small: "eerste reactie" },
          { big: "2 WEKEN", small: "gemiddelde plaatsingstijd" },
          { big: "6 WEKEN", small: "maximale termijn" },
        ],
        disclaimer:
          "Als uw budget en criteria aansluiten bij de markt, plaatsen wij de grote meerderheid van onze klanten gemiddeld binnen 2 weken en uiterlijk binnen 6 weken in een woning.",
      },
      sales: {
        overline: "Waarom Hollanda Emlak?",
        title: "De snelste en meest zorgeloze manier om een woning te vinden",
        cards: [
          { t: "Snelle matching", d: "Wij zoeken woningen die bij uw criteria passen en sturen de beste opties binnen 48 uur." },
          { t: "Turkse ondersteuning", d: "Van gesprek tot contract staan we in elke stap in uw eigen taal naast u." },
          { t: "Veilig contract", d: "U huurt rechtstreeks van Hollanda Emlak, met ons eigen huurcontract." },
          { t: "Ervaren adviseurs", d: "Professioneel procesbeheer met een team met 10+ jaar ervaring in de sector." },
          { t: "Transparant proces", d: "Geen verborgen kosten of verrassingen. U weet vooraf wat u kunt verwachten." },
          { t: "1 jaar gratis ondersteuning", d: "Na het vinden van een geschikte woning krijgt u 1 jaar lang gratis volledige ondersteuning rondom de gehuurde woning." },
        ],
      },
      steps: {
        overline: "Hoe het werkt",
        title: "In drie stappen naar uw nieuwe woning",
        items: [
          { n: "01", t: "Vul het formulier in", d: "3 minuten — vertel ons wat u zoekt." },
          { n: "02", t: "Wij sturen passende woningen", d: "Binnen 48 uur delen we de eerste opties." },
          { n: "03", t: "Bezichtiging en contract", d: "Gemiddeld binnen 2 weken in uw nieuwe woning." },
        ],
        disclosureShort: "",
      },
      faq: {
        overline: "Huurder FAQ",
        title: "Meestgestelde vragen van huurders",
        items: [
          { q: "Van wie huur ik als huurder de woning?", a: "Afhankelijk van uw budget, uw documentsituatie en uw zoekcriteria helpen wij u bij het huren van particuliere verhuurders of van zakelijke woningbedrijven." },
          { q: "Hoe snel vind ik een woning?", a: "Als uw budget en criteria aansluiten bij de markt, plaatsen wij de grote meerderheid van onze klanten gemiddeld binnen 2 weken en uiterlijk binnen 6 weken. Dit is geen garantie, maar onze gemiddelde prestatie." },
          { q: "Wat gebeurt er als er binnen 6 weken geen woning is gevonden?", a: "Eerlijk gezegd weten we het niet, want dat is ons nog nooit overkomen! :) Maar als er binnen 6 weken geen woning wordt gevonden, ontvangt u van ons geen enkele factuur en betaalt u ons niets. Heeft u eerder iets betaald, dan wordt dat volledig aan u terugbetaald." },
          { q: "Welke documenten moet ik aanleveren?", a: "Meestal standaarddocumenten zoals identiteitsbewijs, inkomensbewijs en werkgeversverklaring. Soms is een referentie van een vorige verhuurder handig; we laten u weten wat nodig is." },
          { q: "In welke steden zijn jullie actief?", a: "Wij zijn in heel Nederland actief. Aanvragen in Amsterdam, Rotterdam, Den Haag, Utrecht, Eindhoven en alle andere steden nemen we in behandeling." },
        ],
      },
    },

    form: {
      overline: "Begin hier",
      ownerTitle: "Gratis taxatie voor uw woning",
      tenantTitle: "Laten we passende woningen vinden",
      step: "Stap", of: "/", next: "Volgende", back: "Terug", submit: "Aanvraag versturen", submitting: "Versturen…",
      ownerReminder: "Deze dienst is volledig gratis voor verhuurders. U ontvangt uw volledige huurbedrag.",
      addressPrivacy: "Uw adresgegevens worden uitsluitend gebruikt om uw woning te beoordelen en worden niet met derden gedeeld.",
      tenantDisclosure: "Door akkoord te gaan, bevestigt u dat u de woning rechtstreeks van Hollanda Emlak huurt, niet van de eigenaar.",
      steps: { look: "Wat zoekt u", situation: "Uw situatie", contact: "Contact", property: "Woninggegevens", rental: "Verhuurdetails" },
      labels: {
        postcode: "Postcode", huisnummer: "Huisnummer", toevoeging: "Toevoeging (opt.)", street: "Straatnaam", city: "Plaats",
        manualToggle: "Ik wil het adres handmatig invoeren", addressConfirm: "Klopt dit?",
        propertyType: "Type woning", rooms: "Aantal kamers", sqm: "Oppervlakte (m²)", furnishing: "Inrichting",
        rent: "Gewenste maandhuur (€)", availableDate: "Beschikbaar vanaf", inschrijving: "Inschrijving (BRP) mogelijk?",
        description: "Extra toelichting (opt.)", photos: "Foto's uploaden (opt., max 5)",
        name: "Naam", phone: "Telefoon", email: "E-mail", channel: "Voorkeurskanaal voor contact",
        consent: "Ik ga akkoord met de verwerking van mijn persoonsgegevens (AVG/GDPR).",
        cities: "Gewenste stad(en)", citiesPlaceholder: "Typ een stad, druk op Enter",
        minRooms: "Minimaal aantal kamers", budget: "Maandbudget (€)", moveDate: "Verhuisdatum",
        stayDuration: "Geplande verblijfsduur", occupants: "Aantal bewoners", workStatus: "Werksituatie",
        income: "Bruto jaarinkomen", pets: "Huisdier", smoking: "Roken", inschrijvingNeeded: "Is inschrijving nodig?",
      },
      options: {
        propertyTypeOwner: ["Appartement", "Vrijstaand huis", "Studio", "Kamer", "Overig"],
        propertyTypeTenant: ["Appartement", "Vrijstaand huis", "Studio", "Kamer", "Maakt niet uit"],
        furnishing: ["Gemeubileerd", "Gestoffeerd", "Kaal"],
        yesNoMaybe: ["Ja", "Nee", "Bespreekbaar"], yesNo: ["Ja", "Nee"],
        channel: ["WhatsApp", "Telefoon", "E-mail"], stay: ["6 maanden", "1 jaar", "2+ jaar", "Onbepaald"],
        work: ["Vast contract", "Tijdelijk contract", "ZZP", "Student", "Gepensioneerd", "Overig"],
        income: ["Onder €25.000", "€25.000–40.000", "€40.000–60.000", "Boven €60.000"], pets: ["Ja", "Nee"],
      },
      budgetWarning: "Met dit budget kan het in deze stad langer duren — we sturen u toch de best passende opties.",
      errors: {
        required: "Dit veld is verplicht", postcode: "Voer een geldige postcode in (1234 AB)",
        email: "Voer een geldig e-mailadres in", phone: "Voer een geldig telefoonnummer in", consent: "U moet akkoord gaan om verder te gaan",
      },
      thanksOwner: { title: "Uw aanvraag is ontvangen!", body: "We nemen binnen 24 uur contact met u op via WhatsApp.", reminder: "Ter herinnering: deze dienst is volledig gratis voor u." },
      thanksTenant: { title: "Uw aanvraag is ontvangen!", body: "Binnen 48 uur beginnen we u passende woningen te sturen.", reminder: "Onze gemiddelde plaatsingstijd is 2 weken." },
      followInsta: "Volg ons op Instagram",
    },

    footer: {
      tagline: "Betrouwbaar huren in Nederland. Geen bemiddelaar, maar directe verhuurder.",
      contact: "Contact", links: "Links", privacy: "Privacybeleid", terms: "Gebruiksvoorwaarden",
      kvk: "KVK-nr", btw: "BTW-nr", rights: "Alle rechten voorbehouden.",
    },
    cookie: {
      text: "We gebruiken cookies om uw ervaring te verbeteren en verkeer te analyseren. Voor analytische cookies vragen we uw toestemming.",
      accept: "Accepteren", reject: "Alleen noodzakelijk", link: "Privacybeleid",
    },
    legal: { privacyTitle: "Privacybeleid", termsTitle: "Gebruiksvoorwaarden", close: "Sluiten" },
    whatsapp: "Stuur ons een WhatsApp",
  },
};
